var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BaseSelect", {
    attrs: {
      options: _vm.options,
      label: _vm.$t("lang.speed.msg"),
      value: _vm.value
    },
    on: {
      input: function($event) {
        _vm.$emit("input", parseInt($event.target.value, 10))
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }